import { Grid2, Paper,useTheme } from "@mui/material";
import GridHeader from "./GridHeader";
import GridBody from "./GridBody";
import PageNavigator from "./PageNavigator";

const GridRowLayout = ({ type,
    columns,
    activeColumns,
    activeSort,
    setActiveSort,    
    sortInverted,
    setSortInverted,    
    loading,
    data,
    isCards,
    onClick,
    filters,
    setActiveColumns,
    setPageIndex,
    pageLength,
    pageIndex,
    nextPage,
    pageInfo,
    previousPage,
    multiSelectedItemOptions,
    getSelectedItemOptions,
    handleSetSelectedItems,
    selectedItems,
    getItemOptions,
}) => {
    const theme = useTheme()
    let usedColumns=[];
    for(var j = 0; j < activeColumns.length; j++){
  for(var i = 0; i < columns.length; i++){
    
    if(columns[i].propertyName===activeColumns[j]){
      usedColumns.push(columns[i])
    }  
  } }
    return (<Grid2 component={isCards?Paper:null} style={{ padding: theme.spacing() }}>
        <Grid2>
            <GridHeader
                typeName={type}
                allColumns={columns}
                activeColumns={activeColumns}
                usedColumns={usedColumns}                
                activeSort={activeSort}
                setActiveSort={setActiveSort}
                setActiveColumns={setActiveColumns}
                sortInverted={sortInverted}
                setSortInverted={setSortInverted}
            />
            <GridBody
                loading={loading}
                pageLength={pageLength}
                columns={usedColumns}
                data={data}
                onClick={onClick}                
                filters={filters}
                multiSelectedItemOptions={multiSelectedItemOptions}
                getSelectedItemOptions={getSelectedItemOptions}
                handleSetSelectedItems={handleSetSelectedItems}
                selectedItems={selectedItems}
                getItemOptions={getItemOptions}
            />
            <PageNavigator
                setPage={setPageIndex}
                pageLength={pageLength}
                pageIndex={pageIndex}
                nextPage={nextPage}
                hasPreviousPage={pageInfo?.hasPreviousPage}
                hasNextPage={pageInfo?.hasNextPage}
                previousPage={previousPage}
                dataLength={data?.items.length ?? 0}
                totalCount={data?.totalCount ?? 0}
            />
        </Grid2 >
    </Grid2>
    )
}
export default GridRowLayout;